import React from "react";
import { Card, Row, Col, Typography, Button } from "antd";
const { Title, Text } = Typography;

export default function ResponseModal({
  closeAction,
  addAction,
  isSuccess,
  message,
}) {
  const styles = {
    rootWrapper: { display: "flex", justifyContent: "center" },
    rootCard: { marginTop: "100px", width: "600px" },
    headerRow: { display: "flex", justifyContent: "center" },
    informationRow: { display: "flex", justifyContent: "center" },
    buttonWrapperRow: { marginTop: "50px" },
    buttonWrapperCol: { display: "flex", justifyContent: "flex-end" },
    buttonFix: { marginLeft: "5px" },
  };
  return (
    <div style={styles.rootWrapper}>
      <Card style={styles.rootCard}>
        <Row style={styles.headerRow}>
          {isSuccess === true ? (
            <Title level={2}>Invitation Sent!</Title>
          ) : (
            <Title level={2}>Invitation Error!</Title>
          )}
        </Row>
        <Row style={styles.informationRow}>
          {isSuccess === true ? (
            <Text>
              {message
                ? message
                : `Your Invitation has been sent to the provided email`}
            </Text>
          ) : (
            <Text>
              {message
                ? message
                : `Your Invitation has been sent to the provided email`}
            </Text>
          )}
        </Row>

        <Row style={styles.buttonWrapperRow}>
          <Col xs={18} sm={18} lg={13} xl={13}></Col>
          <Col xs={14} sm={14} lg={11} xl={11} style={styles.buttonWrapperCol}>
            <Button onClick={closeAction}>CLOSE</Button>
            {isSuccess === true && (
              <Button onClick={addAction} style={styles.buttonFix}>
                ADD ANOTHER
              </Button>
            )}
          </Col>
        </Row>
      </Card>
    </div>
  );
}
